import { type FC } from 'react'
import { useIntl } from 'react-intl'
import { useTheme } from '@mui/material/styles'

import Media from '@DS/components/components/media/atoms/media/Media'
import { svgLazyLoader } from '@Utils/icons'
import { getSrcImage } from '@Utils/images'

import LogoRegion from '../../../../public/logo_RS_dark.png'

import ODSearchExternalLink from './ODSearchExternalLink'
import * as styles from './styles'

const BrandLogoDark = svgLazyLoader('brandLogo/zou_dark')

export type ODSearchExternalHeaderProps = {
  homePath?: string
  regionSudURL?: string
}

const ODSearchExternalHeader: FC<ODSearchExternalHeaderProps> = ({ homePath, regionSudURL }) => {
  const theme = useTheme()
  const { formatMessage } = useIntl()

  // The built widget returns a string, while the Storybook environment returns an object
  const imageSrc = getSrcImage(LogoRegion)

  return (
    <div css={styles.odSearchExternalHeader(theme)}>
      <ODSearchExternalLink href={homePath} aria-label={formatMessage({ id: 'widget_header_brandLink_ariaLabel' })}>
        <BrandLogoDark css={styles.brandIcon} />
      </ODSearchExternalLink>
      <ODSearchExternalLink
        href={regionSudURL}
        aria-label={formatMessage({ id: 'widget_header_regionLink_ariaLabel' })}
      >
        <Media src={imageSrc} css={styles.brandIcon} loading="lazy" />
      </ODSearchExternalLink>
    </div>
  )
}

export default ODSearchExternalHeader
